import { isAdminNotConsultant } from "@/js/http/auth.js";
import AdminProductsSubMenusLinks from "@/components/menu/sub-menus/products/AdminProductsSubMenusLinks.vue";
import ProductDetails from "@/components/products/WineComponent.vue";
export default {
  name: "AdminSpiritDetails",
  components: {
    AdminProductsSubMenusLinks: AdminProductsSubMenusLinks,
    ProductDetails: ProductDetails
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      id: null,
      returnRoute: "",
      routeParam: ""
    };
  },
  created: function created() {
    this.id = this.$route.params.id;
    this.searchCriterias = this.$route.params.searchCriterias;
    this.returnRoute = this.$route.params.returnRoute;
    this.routeParam = this.$route.params.routeParam;
  },
  methods: {
    isAdminNotConsultant: isAdminNotConsultant
  }
};